import { Component,ViewChild,TemplateRef } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-registration-done',
  templateUrl: './registration-done-modal.component.html',
  styleUrls: ['./registration-done-modal.component.scss']
})
export class RegistrationDoneModalComponent {
registrationApprovalRequired = environment.registrationApprovalRequired;
//#region INPUT, OUTPUT, VIEWCHILD
@ViewChild('registrationDoneModal') registrationDoneTemplate!: TemplateRef<RegistrationDoneModalComponent>;
//#endregion
}
